import axios from "axios";
import { GET_ERRORS } from "./types";

export const startStripeCheckout = (payload) => (dispatch) => {
  localStorage.setItem("pendingStripeCheckout", JSON.stringify(payload));

  return axios
    .post("/api/stripe/checkout-session", payload)
    .then((res) => {
      window.location.href = res.data.url;
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response ? err.response.data : { message: err.message },
      });
    });
};
